/**
 * Nomes das flags do Clube de Benefícios (D42) — só constantes.
 *
 * Arquivo à parte, sem dependência de React nem de rede, porque
 * `shared/nav-items.ts` precisa do nome da flag mestre e é importado por
 * módulos e testes puros. Um `import` de hook ali arrastaria o contexto de
 * autenticação e o cliente HTTP para dentro deles.
 *
 * As sete nascem DESLIGADAS na tabela `feature_flag`; ligar é tarefa humana
 * (CLUBE-H4). Hoje o front só consulta a mestre.
 */

/** Mestre: desligada, todo `/v1/clube/*` responde 404 (D42). */
export const FLAG_CLUBE_MESTRE = 'clube.habilitado'
